var _rect, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyCarousel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 45,
    viewBox: "0 0 53 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17.8888,
    y: 0.32049,
    width: 34.4977,
    height: 34.4977,
    rx: 2.24343,
    fill: "white",
    fillOpacity: 0.46,
    stroke: "#7195AD",
    strokeWidth: 0.64098
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.32049,
    y: 9.75799,
    width: 34.4977,
    height: 34.4977,
    rx: 2.24343,
    fill: "white",
    stroke: "#7195AD",
    strokeWidth: 0.64098
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyCarousel);
export default __webpack_public_path__ + "static/media/empty-carousel.f3cfda59ada0e9c14c5d95ace093e9c7.svg";
export { ForwardRef as ReactComponent };